import $ from 'jquery';
import Widget from "lib/widget"
import AjaxForm from "servos/ajaxForm";
import AjaxFileForm from "servos/ajaxFileForm";
import { showFlashToast } from "mixins/flash";
import uuid from 'uuid/v4';
import Inputmask from "inputmask";
import { initBootstrapComponents } from "lib/bootstrapTooltips";
import initDatepicker from '../../initializers/input_components/datepicker';

class InspectionsListWidget extends Widget {
  constructor(thisRoot, inspectionModalContainer, inspectionsTabRoot) {
    super();
    this.root = thisRoot
    this.modalContainer = this.root.find(inspectionModalContainer)
    this.inspectionsRoot = this.root.find(inspectionsTabRoot)
    bindBookInspections.call(this)
    bindRescheduleInspections.call(this)
    bindViewReports.call(this)
    bindReviewReport.call(this)
    bindInspectionBookingDetails.call(this)
    bindSendInspectionReport.call(this)
    bindUndoInspectionReport.call(this)
    bindApproveResolutionForms.call(this)
    bindReportCsi.call(this)
    bindAssignInspector.call(this)
    bindUploadZoneFileNames.call(this)
    bindPopulateDescription.call(this)
  }
}

let bindSendInspectionReport = function () {
  this.inspectionsRoot.on('click', '.send-inspection-report', (e) => {
    let reviewUrl = getOrBuildReviewUrl.call(this, e)
    $.ajax({
      url: reviewUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      initRecipientsSelect()
      this.modalContainer.find('.modal').modal('show');
      this.formElem = this.modalContainer.find('form');
    })
  })
}
// Initialize the additional email addresses select2 in _send_report_modal.slim.
// We do it here instead of in initializers/input_components/select2.js because the 
// HTML does not exist when the select2 initialiser runs, but exists when the user clicks 'Share PDF', 
// the AJAX call occurs, and the response.html is added to the send inspection modal. 
let initRecipientsSelect = function () {
  $('.recipients-select').select2({
    placeholder: "",
    allowClear: true,
    multiple: true,
    theme: "bootstrap",
    tags: true,
    width: "resolve",
    minimumResultsForSearch: Infinity,
  }).on('change', () => {
    controller.emit('select2-changed', this)
  })
}

let bindUndoInspectionReport = function () {
  this.root.on('click', '.undo-inspection-report', (e) => {
    let removalUrl = e.currentTarget.dataset.url
    swal({
      title: "Are you sure you want to remove this report",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: `Sure`,
    }).then((confirm) => {
      if (confirm.value === true) {
        $.ajax({
          url: removalUrl,
          method: "delete",
          dataType: "json"
        }).done(() => {
          location.reload()
        })
      }
    })
  })
}

let bindViewReports = function () {
  this.inspectionsRoot.on('click', '.view-reports', (e) => {
    let reviewUrl = getOrBuildReviewUrl.call(this, e)
    $.ajax({
      url: reviewUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      this.modalContainer.find('.modal').modal('show');
      this.formElem = this.modalContainer.find('form');
      bindResolutionForms.call(this)
      bindApproveResolutionForms.call(this)
    })
  })
}

let bindReviewReport = function () {
  this.inspectionsRoot.on('click', '.review-reports', (e) => {
    let reviewUrl = getOrBuildReviewUrl.call(this, e)
    $.ajax({
      url: reviewUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      initDatepicker();
      this.modalContainer.find('.modal').modal('show');
      this.formElem = this.modalContainer.find('form');

      // rewrite this to listen for submit of form and submit the closest

      $("form#update-report").on("submit", (e) => {
        this.modalContainer.find('.modal').modal('hide');
      })

      // External Pages - create/update resolutions to non compliant items
      bindResolutionForms.call(this)
      bindToggleSatisfactoryInspection.call(this)
      // Internal Pages - approve/decline resolutions to non compliant items
      bindApproveResolutionForms.call(this)
      hookCocoonToAssignUniqueIdsToNestedFields.call(this)
      assignUniqueIdsToNestedFields.call(this)
    })
  })
}


let bindToggleSatisfactoryInspection = function () {
  _.each(this.modalContainer.find('.inspection-report'), (container) => {
    bindInspectionForm.call(this, container)
  });
}

let bindInspectionForm = (container) => {
  var $container = $(container)

  if (["unsatisfactory", "satisfactory_minor"].includes($container.find("input[type='radio']:checked").val())) {
    $container.find('.non-compliant-fields').removeClass('d-none')
  } else {
    $container.find('.non-compliant-fields').addClass('d-none')
  }

  $container.find("input[type='radio']").on('change', (e) => {
    if (["unsatisfactory", "satisfactory_minor"].includes(e.target.value)) {
      $container.find('.non-compliant-fields').removeClass('d-none')
    } else {
      $container.find('.non-compliant-fields').addClass('d-none')
    }
  })
}

let hookCocoonToAssignUniqueIdsToNestedFields = function () {
  $(document).on('cocoon:after-insert', () => {
    assignUniqueIdsToNestedFields.call(this)
  })
}

let bindPopulateDescription = function () {
  $(document).on("change", ".description-template", (event) => {
    const source = $(event.target)
    source.closest('.nested-fields').find('.description-input').val(source.val())
  })
}

let assignUniqueIdsToNestedFields = function () {
  $(".nested-fields").each((index, ele) => {
    const id = uuid()
    const trigger = $(ele).find(".description-template")
    const fields = $(ele).find(".description-input")
    $(trigger).attr("uid", id)
    $(fields).attr("id", id)
  })
}

let bindUploadZoneFileNames = function () {
  $(document).on('change', '.nci-upload-input', (event) => {
    const input = event.target
    const files = Array.from(input.files)
    const textEl = $(input).closest('.nci-upload-zone').find('.nci-upload-text')
    if (files.length === 0) {
      textEl.text('Browse to select files')
    } else if (files.length === 1) {
      textEl.text(files[0].name)
    } else {
      textEl.text(`${files.length} files selected`)
    }
    $(input).closest('.nci-upload-zone').addClass('nci-upload-zone--has-files')
  })
}

// Internal pages - certifier can approve/decline a client's resolution
let bindApproveResolutionForms = function () {
  _.each(this.modalContainer.find('#resolution-fields').closest('form'), (form) => {
    bindApproveResolutionForm.call(this, form)
  });
}

// Internal pages - hook Ajax form to approve resolution form
let bindApproveResolutionForm = function (form) {
  var $form = $(form)

  // submit form with decline action
  $form.find('.btn-decline, .btn-approve').on('click', (e) => {
    let formactionUrl = e.currentTarget.dataset.formaction;
    $(e.currentTarget).prop("disabled", true)
    $(e.currentTarget).addClass("disabled")
    $form.attr('action', formactionUrl);
    $form.submit();
  })

  let ajaxForm = new AjaxFileForm($form)
  ajaxForm.on('success', successApproveResolutionResponse.bind(this, $form))
  ajaxForm.on("error", errorApproveResolutionResponse.bind(this, $form))
}

// Internal pages - approve resolution form successful calback
let successApproveResolutionResponse = function (form, response) {
  let itemRow = this.inspectionsRoot.find(`.inspection-item[data-item-id="${response.data.id}"]`)
  itemRow.replaceWith(response.data.rowHtml);
  form.closest('.non-compliant-item').replaceWith(response.data.html);
  initBootstrapComponents(this.inspectionsRoot);
  this.root.find('#non-compliant-items-label ').html(response.data.report.non_compliant_items_label)
  this.modalContainer.find('.modal').modal('hide');
}

// Internal pages - approve resolution form failure calback
let errorApproveResolutionResponse = function (form, response) {
  // get the form id
  let formId = form.prop("id")
  form.replaceWith(response.jqXHR.responseJSON.html);
  initBootstrapComponents(this.modalContainer);
  // hook new form to ajax file form
  let newForm = this.root.find(`#${formId}`)
  let ajaxForm = new AjaxFileForm(newForm)
  ajaxForm.on('success', successApproveResolutionResponse.bind(this, newForm))
  ajaxForm.on("error", errorApproveResolutionResponse.bind(this, newForm))
}

// External pages - client/account can create/update resolutions
let bindResolutionForms = function () {
  _.each(this.modalContainer.find('form.resolution-form'), (form) => {
    bindResolutionFrom.call(this, form)
  });
}

// External pages - hook Ajax form to resolution form
let bindResolutionFrom = function (form) {
  let ajaxForm = new AjaxFileForm($(form))
  ajaxForm.on('success', successResolutionResponse.bind(this, $(form)))
  ajaxForm.on("error", errorResolutionResponse.bind(this, $(form)))
}

// External pages - resolution form successful calback
let successResolutionResponse = function (form, response) {
  form.closest('.document-panel').replaceWith(response.data.html);
  initBootstrapComponents(this.inspectionsRoot);
}

// External pages - resolution form failure calback
let errorResolutionResponse = function (form, response) {
  // get the form id
  let formId = form.prop("id")
  form.replaceWith(response.jqXHR.responseJSON.html);
  initBootstrapComponents(this.modalContainer);
  // hook new form to ajax file form
  let newForm = this.root.find(`#${formId}`)
  let ajaxForm = new AjaxFileForm(newForm)
  ajaxForm.on('success', successResolutionResponse.bind(this, newForm))
  ajaxForm.on("error", errorResolutionResponse.bind(this, newForm))
}


let initBookingDatepicker = function (container) {
  const input = container.find('input[type="date"][data-booking="true"]')[0];
  if (!input || input._flatpickr) return;

  const hd = new Holidays('AU', 'NSW');
  const publicHolidays = hd.getHolidays(new Date().getFullYear()).map(h => h.date.split(' ')[0]);
  const tenantBlockoutDates = JSON.parse(document.body.dataset.blockoutDates || '[]');
  const minDate = new Date();
  minDate.setDate(minDate.getDate() + 3);
  // Truncate to midnight: otherwise minDate keeps "now"'s time-of-day, and a
  // date exactly 3 days out (parsed as midnight) compares as earlier than it.
  minDate.setHours(0, 0, 0, 0);

  flatpickr(input, {
    dateFormat: 'Y-m-d',
    altInput: true,
    altFormat: 'd/m/Y',
    allowInput: true,
    appendTo: document.body,
    minDate,
    disable: [
      ...publicHolidays,
      ...tenantBlockoutDates,
      date => date.getDay() === 0 || date.getDay() === 6
    ]
  });
}

// Internal + External pages - Booking an inspection
let bindBookInspections = function () {
  this.inspectionsRoot.on('click', '.book-inspection', (e) => {
    let bookUrl = getOrBuildBookUrl.call(this, e)
    $.ajax({
      url: bookUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      this.emit('form-loaded');
      initDatepicker();

      this.modalContainer.find('.modal').modal('show');
      this.formElem = this.modalContainer.find('form');
      this.ajaxForm = new AjaxForm(this.formElem)
      this.ajaxForm.on('success', updateItemRow.bind(this))
      this.ajaxForm.on("error", errorResponse.bind(this))

    })
  })
}

let bindRescheduleInspections = function () {
  this.inspectionsRoot.on('click', '.reschedule-inspection', (e) => {
    let rescheduleUrl = getOrBuildRescheduleUrl(e)
    $.ajax({
      url: rescheduleUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      this.emit('form-loaded');
      initDatepicker();

      this.modalContainer.find('.modal').modal('show');
      this.formElem = this.modalContainer.find('form');
      this.ajaxForm = new AjaxForm(this.formElem)
      this.ajaxForm.on('success', updateItemRow.bind(this))
      this.ajaxForm.on("error", errorResponse.bind(this))

    })
  })
}

let bindInspectionBookingDetails = function () {
  this.inspectionsRoot.on('click', '.view-inspection-booking-details', (e) => {
    let bookUrl = getOrBuildBookUrl.call(this, e)
    $.ajax({
      url: bookUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      this.modalContainer.find('.modal').modal('show');
    })
  })
}

let getOrBuildReviewUrl = function (e) {
  if (e.currentTarget.dataset.url != undefined) {
    return e.currentTarget.dataset.url
  } else {
    return `${gon.base_namespace}/checklist_items/${e.currentTarget.dataset.itemId}/inspection_report`
  }
}

// this widget is shared with the external pages.
// For external pages we don't pass the url but the item id instead.
let getOrBuildBookUrl = function (e) {
  if (e.currentTarget.dataset.url != undefined) {
    return e.currentTarget.dataset.url
  } else {
    return `${gon.base_namespace}/checklist_items/${e.currentTarget.dataset.itemId}/book_modal`
  }
}

let getOrBuildRescheduleUrl = function (e) {
  if (e.currentTarget.dataset.url != undefined) {
    return e.currentTarget.dataset.url
  } else {
    return `${gon.base_namespace}/checklist_items/${e.currentTarget.dataset.itemId}/reschedule_modal`
  }
}

// update item row
let updateItemRow = function (response) {
  this.modalContainer.find('.modal').modal('hide');
  let itemRow = this.inspectionsRoot.find(`.inspection-item[data-item-id="${response.data.item.id}"]`)
  itemRow.replaceWith(response.data.item.html);
  initBootstrapComponents(this.inspectionsRoot);
  this.root.find('#inspection-badge').html(response.data.project.outstanding_inspection_badge)
  this.root.find('#project-checklist-labels').html(response.data.project.checklist_labels)
  this.emit('item-updated')
}


let errorResponse = function (response) {
  const json = response && response.jqXHR && response.jqXHR.responseJSON;
  if (!json) return;

  const html = json.formHtml || json.html;
  if (!html) return;

  this.formElem.replaceWith(html);
  this.formElem = this.modalContainer.find('form');
  initBootstrapComponents(this.modalContainer);
  bindAjaxForm.call(this);
  this.emit('form-loaded');
}

let bindReportCsi = function () {
  this.root.on('click', '.report-csi', (e) => {
    let reportCsiUrl = e.currentTarget.dataset.url
    swal({
      title: "Are you sure you want to report this inspection to the Planning Portal?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes`,
    }).then((confirm) => {
      if (confirm.value === true) {
        $.ajax({
          url: reportCsiUrl,
          method: "get",
          dataType: "json"
        }).done(() => {
          location.reload()
        })
      }
    })
  })
}

let bindAssignInspector = function () {
  this.inspectionsRoot.on('change', '.inspector-select', (e) => {
    const $select = $(e.currentTarget)
    const previousValue = $select.data('previous-value')
    const form = $select.closest('form')

    $.ajax({
      url: form.attr('action'),
      method: 'patch',
      dataType: 'json',
      data: form.serialize(),
      error: function (xhr) {
        $select.val(previousValue)
        const errors = xhr.responseJSON?.errors || []
        const message = errors[0] || 'Inspector could not be updated.'
        showFlashToast(message, { type: 'error' })
      }
    })
  })

  this.inspectionsRoot.on('mousedown', '.inspector-select', (e) => {
    $(e.currentTarget).data('previous-value', $(e.currentTarget).val())
  })
}

export default InspectionsListWidget
